export const FETCH_TOOLBAR_INSTANCES = 'FETCH_TOOLBAR_INSTANCES'
export const FETCH_TOOLBAR_INSTANCES_SUCCESS = `${FETCH_TOOLBAR_INSTANCES}_SUCCESS`

export const DELETE_TOOLBAR_INSTANCE = 'DELETE_TOOLBAR_INSTANCE'
export const DELETE_TOOLBAR_INSTANCE_SUCCESS = `${DELETE_TOOLBAR_INSTANCE}_SUCCESS`

export const ADD_TOOLBAR_INSTANCE = 'ADD_TOOLBAR_INSTANCE'
export const ADD_TOOLBAR_INSTANCE_SUCCESS = `${ADD_TOOLBAR_INSTANCE}_SUCCESS`

export const UPDATE_TOOLBAR_INSTANCE = 'UPDATE_TOOLBAR_INSTANCE'
export const UPDATE_TOOLBAR_INSTANCE_SUCCESS = `${UPDATE_TOOLBAR_INSTANCE}_SUCCESS`

export const SET_CURRENT_TOOLBAR = 'SET_CURRENT_TOOLBAR'
export const CLEAR_CURRENT_TOOLBAR = 'CLEAR_CURRENT_TOOLBAR'
